import { UI_SHARED_BUTTON__prompt_use_english_tokens } from '@/components/shared/UI_SHARED_BUTTON__prompt_use_english_tokens';
import { use_slice_search } from '@/hooks/store/use_slices';
import i18n_page_search from '@/locales/keys/i18n_page_search.json';
import { BarWorkspaceEntityOrBarLine } from '@/pages/_base/views/BarWorkspaceEntityOrBarLine';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { useTranslation } from 'react-i18next';
import { SButtonHideUnusedTokens } from './SPromptButtonHideUnsusedTokens';

export function SPromptBarHeader() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SEARCH);

  const { search_current } = use_slice_search(['search_current']);

  const render_view = () => {
    return (
      <div className="w-full flex justify-between items-center ">
        <p className="ml-4 text-base text-bar-foreground">{t(i18n_page_search.sidebar.prompt_component.title)}</p>
        <div className="flex flex-row justify-between gap-1 items-center">
          <UI_SHARED_BUTTON__prompt_use_english_tokens />
          <SButtonHideUnusedTokens />
        </div>
      </div>
    );
  };

  return <BarWorkspaceEntityOrBarLine view={render_view()} entity={search_current} required_permission={ENUM__workspace_entity_feature.ENTITY_SEARCH_VIEW} />;
}
